import { cn } from '@/lib/utils';

/** Preset "grid" (claro, institucional): patrón de puntos con máscara radial + un glow verde estático. */
export function GridBackground({ className }: { className?: string }) {
  return (
    <div className={cn('absolute inset-0 overflow-hidden bg-brand-offwhite dark:bg-brand-dark', className)} aria-hidden>
      <div
        className="absolute inset-0 opacity-60 dark:opacity-30"
        style={{
          backgroundImage: 'radial-gradient(rgba(20,20,20,.18) 1px, transparent 1px)',
          backgroundSize: '22px 22px',
          maskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, #000 40%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, #000 40%, transparent 100%)',
        }}
      />
      <div
        className="absolute right-[-10%] top-[-30%] h-[46vw] w-[46vw] rounded-full blur-[60px] opacity-50"
        style={{ background: 'radial-gradient(closest-side, rgba(28,201,185,.6), transparent)' }}
      />
    </div>
  );
}
